module.exports = __webpack_public_path__ + "img/01.07e64d0b.png";